export default __webpack_public_path__ + "static/media/set-fan-overlay.632b992c.png";